module.exports = __webpack_public_path__ + "img/img7.e6980fa1.svg";